import React, { useState } from "react";
import SearchForm, { FormValues } from "./components/SearchForm";
import { usePagination } from "ahooks";
import { getEwaybillAccountMapping, getSharedEwaybillAccountList } from "@/services/api/sharedEwaybillAccount";
import { Card, Form, Table } from "antd";
import UserType from "@/enum/UserType";
import useConsumerTableColumns from "./hooks/useConsumerTableColumns";
import ModalStoreProvider from "@/hooks/Modal/ModalStoreProvider";

interface ConsumerSharedEwaybillAccountProps {}

// 电子面单共享使用端页面
const _ConsumerSharedEwaybillAccount: React.FC<ConsumerSharedEwaybillAccountProps> = function (props) {
  const [searchValue, setSearchValue] = useState<any>({});
  const [form] = Form.useForm<FormValues>();

  const { data, loading, pagination, refresh } = usePagination(
    async (page) => {
      const values = form.getFieldsValue();

      const result = await getSharedEwaybillAccountList({
        ...values,
        pageNo: page.current,
        pageSize: page.pageSize,
        userType: UserType.CONSUMER,
      });

      const {
        allShippingAddresses,
        ewaybillShippingAddressMapping,
        ewaybillAccountMapping,
        branchAccountMapping,
        subscriptionMapping,
      } = getEwaybillAccountMapping(result.content);

      return {
        ewaybillShippingAddressMapping,
        ewaybillAccountMapping,
        branchAccountMapping,
        subscriptionMapping,
        total: result.totalElements,
        list: allShippingAddresses,
      };
    },
    {
      defaultPageSize: 10,
      refreshDeps: [searchValue],
    }
  );

  const columns = useConsumerTableColumns({
    ewaybillShippingAddressMapping: data?.ewaybillShippingAddressMapping,
    ewaybillAccountMapping: data?.ewaybillAccountMapping,
    branchAccountMapping: data?.branchAccountMapping,
    subscriptionMapping: data?.subscriptionMapping,
    reload: refresh,
    data: data?.list,
  });

  return (
    <Card>
      <SearchForm
        form={form}
        onSearch={() => {
          const values = form.getFieldsValue();

          setSearchValue(values);
        }}
        onReset={() => {
          form.resetFields();

          setSearchValue({});
        }}
      />

      <Table
        rowKey={(row, index) => index}
        size="small"
        loading={loading}
        columns={columns}
        dataSource={data?.list}
        pagination={{
          ...pagination,
          showQuickJumper: true,
          showTotal: (total) => `总共 ${total} 个项目`,
          showSizeChanger: true,
          pageSizeOptions: ["10", "50", "100", "200"],
        }}
      />
    </Card>
  );
};

const ConsumerSharedEwaybillAccount: React.FC<any> = function (props) {
  return (
    <ModalStoreProvider>
      <_ConsumerSharedEwaybillAccount />
    </ModalStoreProvider>
  );
};

export default React.memo(ConsumerSharedEwaybillAccount);
